import React from "react";
import "../css/timeline.css"; // New styles for the unique display
import "../css/style.css"; // Global styles

function Education() {
  return (
    <div className="education-page-container">
      <h1 className="section-title mb-5">Educational Journey</h1>

      <div className="education-sections-wrapper">
        <div className="education-section-item">
          <div className="education-title-wrapper">
            <h2>Master of Science in Computer Science and Engineering</h2>
            <span className="education-years">Sep 2024 - Dec 2025</span>
          </div>
          <h3>
            University of California, San Diego (UC San Diego){" "}
            <span className="education-gpa">GPA: 3.9/4.0</span>
          </h3>
          <p className="education-coursework-title">Key Coursework:</p>
          <p className="education-description">
            Sociotechnical cybersecurity, Natural Language Processing, Networked
            systems, Legacy of Cypherpunks, Algorithm Design and Analysis,
            Machine Learning Algorithms
          </p>
        </div>

        <div className="education-section-item">
          <div className="education-title-wrapper">
            <h2>Bachelor of Technology in Computer Science and Engineering</h2>
            <span className="education-years">Jul 2018 - Jun 2022</span>
          </div>
          <h3>
            SASTRA University, Tamil Nadu, India{" "}
            <span className="education-gpa">Grade: 9.07/10.0</span>
          </h3>
          <p className="education-coursework-title">Key Coursework:</p>
          <p className="education-description">
            Computer Networks, Cryptography and Network Security, Artificial
            Intelligence, Operating Systems, Data Structures, Computer
            Organization and Architecture, Theory of Computation, Programming in
            C/C++
          </p>
        </div>

        <div className="education-section-item">
          <div className="education-title-wrapper">
            <h2>High School - Senior Year</h2>
            <span className="education-years">Mar 2016 - Apr 2018</span>
          </div>
          <h3>
            Maharishi Vidya Mandir Senior Secondary School{" "}
            <span className="education-gpa">Grade: 473/500</span>
          </h3>
          <p className="education-coursework-title">Courses:</p>
          <p className="education-description">
            Physics, Chemistry, Mathematics, Computer Science, English
          </p>
        </div>

        <div className="education-section-item">
          <div className="education-title-wrapper">
            <h2>High School - Sophomore Year</h2>
            <span className="education-years">Mar 2004 - Apr 2016</span>
          </div>
          <h3>
            Vidya Peetam Senior Secondary School{" "}
            <span className="education-gpa">Grade: 10/10</span>
          </h3>
          <p className="education-coursework-title">Courses:</p>
          <p className="education-description">
            Science, Social Science, Mathematics, English, Tamil
          </p>
        </div>
      </div>
    </div>
  );
}

export default Education;
